import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Button } from "@/components/ui/Button";
import MobileDrawer from "../MobileDrawer";
import HamburgerIcon from "../assets/HamburgerIcon";
import { MeUser } from "@/hooks/queries/useMe";

export default function MobileNavigation({ user }: { user: MeUser | undefined }) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      <Button
        isIconOnly
        color="default"
        variant="ghost"
        className="size-11 !rounded-none !border-none !p-0 w-fit min-w-fit"
        aria-label="Open menu"
        onPress={() => setIsDrawerOpen(true)}
      >
        <HamburgerIcon className="size-7 text-primary" />
      </Button>
      {mounted &&
        createPortal(
          <MobileDrawer
            isOpen={isDrawerOpen}
            onClose={() => setIsDrawerOpen(false)}
            user={user}
          />,
          document.body
        )}
    </>
  );
}
